<template>
    <el-card>
    <div class="download-app">
        <div class="app">
            <div class="img">
                <img :src="logoPath" :width="logoWidth" alt="app download">
            </div>
            <div class="desc">
                <div class="name">{{appName}} <span class="version">{{version}}</span></div>
                <div class="app-desc">{{slogan}}</div>
            </div>
        </div>
        <div class="download" align="left">
            <slot>
                <el-link :href="downloadPath" target="_blank">
                    <el-button type="danger">下载 app</el-button>
                </el-link>
            </slot>
        </div>
    </div>
    </el-card>
</template>

<script>

export default {
    name: "DownloadApp",
    props: {
        appName: String,
        slogan: {
            type: [String, null],
            default: null,
        },
        logoPath: String,
        logoWidth: {
            type: Number,
            default: 80
        },
        version: {
            type: [String, null],
            default: null
        },
        downloadPath: String
    },
    data() {
        return {
            version: null
        }
    },
    methods: {

    }
}
</script>

<style scoped>

    /deep/ .el-card__body {
        padding: 0;
        max-width: 935px;
    }

    .download-app {
        display: flex;
        flex-direction: row;
        align-items: center;
        width: 100%;
        padding: 10px 0 10px 5px;
    }

    .download-app .app {
        width: 70%;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .download-app .app .img {
        /* background: #000000; */
        width: 30%;
    }

    .download-app .app .desc {
        display: flex;
        flex-direction: column;
        width: 80%;
        align-items: flex-start;
        /*justify-content: center;*/
        padding: 5px 0 5px 10px;
        text-align: left; /* 必须加这个属性，否则微信浏览器不能靠左显示 */
    }

    .download-app .app .desc .name {
        font-weight: 600;
        font-size: 20px;
        line-height: 30px;
    }

    .download-app .app .desc .version {
        font-weight: 400;
        font-size: 14px;
        line-height: 15px;
        margin-left: 4px;
    }

    .download-app .app .desc .app-desc {
        font-size: 14px;
        color: #909399;
        line-height: 25px;
    }

    .download-app .download {
        width: 35%
    }


</style>




// WEBPACK FOOTER //
// src/components/commons/DownloadApp.vue